import { Link } from 'react-router-dom';
import { Mark } from '../components/ui';

export function AccessDeniedPage() {
  return (
    <main className="auth-gate" id="main-content">
      <Mark />
      <span className="danger-icon" aria-hidden="true">
        !
      </span>
      <h1>Access denied</h1>
      <p>
        GitHub authentication completed, but this identity is not in RepoHost’s owner allowlist. No
        owner session was created.
      </p>
      <Link className="button button--quiet" to="/">
        Return to RepoHost
      </Link>
    </main>
  );
}
